import { render, staticRenderFns } from "./ConsumersMessagesAndCalls.vue?vue&type=template&id=31dce3ba&scoped=true"
import script from "./ConsumersMessagesAndCalls.vue?vue&type=script&lang=js"
export * from "./ConsumersMessagesAndCalls.vue?vue&type=script&lang=js"
import style0 from "./ConsumersMessagesAndCalls.vue?vue&type=style&index=0&id=31dce3ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dce3ba",
  null
  
)

export default component.exports